import type { LogStreamStatus } from './logStreamClient';

export interface LogStatusHint {
  text: string;
  // 故障类提示用醒目色，连接中提示用弱化色
  error: boolean;
}

/**
 * 日志面板顶部提示条的文案。
 * 故障提示优先于连接中提示，两者都不适用时返回 null，提示条不占位。
 */
export function resolveLogStatusHint(
  status: LogStreamStatus,
  errorMessage: string,
): LogStatusHint | null {
  if (errorMessage) {
    return { text: errorMessage, error: true };
  }
  if (status === 'connecting' || status === 'reconnecting') {
    return { text: '日志连接中...', error: false };
  }
  return null;
}
